var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrMarketingAndAdvertising = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Advertising-Megaphone--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Advertising Megaphone Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.85 14.29 -2.16 -3.56a0.19 0.19 0 0 1 0 -0.15L22 6.43a1 1 0 0 0 -0.76 -1l-4.05 -1a0.26 0.26 0 0 1 -0.13 -0.08l-2.7 -3.17a1 1 0 0 0 -1.29 -0.25L9.51 3.09a0.28 0.28 0 0 1 -0.15 0l-4.15 -0.3a1 1 0 0 0 -1.06 0.76L3.07 8A1 1 0 1 0 5 8.47l0.83 -3.41a0.25 0.25 0 0 1 0.27 -0.19l3.49 0.28A1 1 0 0 0 10.2 5l3 -1.82a0.26 0.26 0 0 1 0.32 0.05l2.27 2.67a1 1 0 0 0 0.52 0.33l3.41 0.83a0.25 0.25 0 0 1 0.19 0.26l-0.28 3.5a1 1 0 0 0 0.14 0.6l1.82 3a0.25 0.25 0 0 1 -0.05 0.32L18.87 17a1 1 0 0 0 -0.32 0.53l-0.83 3.4a0.26 0.26 0 0 1 -0.27 0.19L14 20.85a1 1 0 0 0 -0.16 2l4.64 0.37a1 1 0 0 0 1 -0.77l1 -4a0.32 0.32 0 0 1 0.08 -0.14l3.18 -2.7a1 1 0 0 0 0.11 -1.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.11 19.23a0.5 0.5 0 0 0 0 0.59l1 1.52a0.49 0.49 0 0 0 0.56 0.2l2.26 -0.67a0.24 0.24 0 0 1 0.28 0.1l0.6 0.91a2.89 2.89 0 0 0 2.4 1.28 2.82 2.82 0 0 0 1.59 -0.48 2.86 2.86 0 0 0 1.1 -3.31 0.3 0.3 0 0 1 0 -0.21 0.31 0.31 0 0 1 0.16 -0.12l4.3 -1a0.24 0.24 0 0 1 0.26 0.1l0.08 0.12a0.73 0.73 0 0 0 0.63 0.33 0.78 0.78 0 0 0 0.41 -0.12 0.76 0.76 0 0 0 0.21 -1L9.59 7.86a0.75 0.75 0 1 0 -1.25 0.83l0.07 0.1a0.26 0.26 0 0 1 0 0.3ZM8 21.43a1.38 1.38 0 0 1 -2 -0.38l-0.26 -0.4a0.24 0.24 0 0 1 0 -0.23 0.26 0.26 0 0 1 0.16 -0.15l2.24 -0.67a0.24 0.24 0 0 1 0.3 0.14A1.38 1.38 0 0 1 8 21.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrMarketingAndAdvertising);
export default ForwardRef;